// Internal libraries
import { appStore } from '@/store';
import { features, logger } from '@/lib';
import { getCurrencyCodeAndValue } from './utils';

const mapProfileShippingMethodsInput = methods => {
  const { form: formState } = appStore.getState();
  const { shippingInsuranceSelected } = formState;
  const isInShippingAndTaxIdTreatment = features.isActive('isShippingAndTaxId');

  if (isInShippingAndTaxIdTreatment) {
    logger.info('IN_GUEST_PROFILE_WPS_SHIPPING_AND_TAX_ID_TREATMENT');
  }

  // Only pass in expected inputs or else the mutation would throw
  // received unexpected inputs errors
  return methods.map(method => {
    const {
      amount,
      cachedId: id,
      hasInsurance: isInsuranceOffered,
      insuranceAmount,
      label,
      taxAmount,
      selected,
      shippingMethodType,
    } = method;
    const shouldUseInsuranceAmount =
      (!isInsuranceOffered && insuranceAmount) || shippingInsuranceSelected;

    // TO-DO: Clean up when FEATURE_GUEST_SHIPPING_AND_TAX_ID experiment is finished
    if (isInShippingAndTaxIdTreatment) {
      return {
        default: method.default,
        id,
        label,
        selected,
        shippingMethodType,
      };
    }

    return {
      default: method.default,
      label,
      selected,
      shippingAmount: getCurrencyCodeAndValue(amount),
      shippingMethodType,
      ...(shouldUseInsuranceAmount && {
        insuranceAmount: getCurrencyCodeAndValue(insuranceAmount),
      }),
      ...(taxAmount && {
        taxAmount: getCurrencyCodeAndValue(taxAmount),
      }),
    };
  });
};
export { mapProfileShippingMethodsInput };
